//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Complain from "./complain";

export default {
    name: "index",
    components: {Complain},
    data() {
        return {
            active: 0,
            currentUser: {
                userId: 0
            },
        }
    },
    methods: {
        getCurrentUserByMember() {
            abp.ajax.get('/api/services/app/WorkOrder/GetCurrentUserByMember').then(res => {
                if (res.data.result != null) {
                    this.currentUser = res.data.result;
                    this.getUserProjects();
                }
            })
        },
        getUserProjects() {
            this.$store.dispatch({
                type: 'member/getUserProjects',
                userId: this.currentUser.userId
            })
        }
    },
    created() {
        this.getCurrentUserByMember();
    }
}
